<main class="cucine-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">
              Pulizia cucine industriali a Pescara e provincia
            </h1>

            <p class="mb-0 hero-sub">
              Con <strong>SAMI Pulizie</strong> garantisci igiene e sicurezza nelle aree di preparazione.
              Interventi mirati di <strong>sanificazione</strong> e <strong>sgrassatura professionale</strong>
              per cucine, cappe, filtri e superfici di lavoro.
              <strong>Sopralluogo gratuito</strong> e piani su misura.
              <br />
              <strong>Utilizziamo prodotti Ecolab</strong> e/o a <strong>basso impatto ambientale</strong>,
              con soluzioni <strong>a base enzimatica</strong> per una pulizia efficace e più sostenibile.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi sopralluogo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama 085 54360</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip">
                <i class="fa-solid fa-kitchen-set"></i> Cucine & laboratori
              </div>
              <div class="chip">
                <i class="fa-solid fa-fire-burner"></i> Cappe, filtri, grassi
              </div>
              <div class="chip">
                <i class="fa-solid fa-shield-virus"></i> Igiene alimentare
              </div>
              <div class="chip">
                <i class="fa-solid fa-leaf"></i> Basso impatto
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/panificio.webp"
                class="hero-img"
                alt="Pulizia e sanificazione cucine industriali"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (1) SEZIONE 2 COLONNE -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Servizi per cucine industriali</h2>

          <p class="text-muted mb-3">
            Nelle cucine professionali l’igiene è fondamentale: grassi, residui e vapori si depositano
            rapidamente su superfici, cappe e filtri. Per questo realizziamo piani di pulizia
            <strong>programmati</strong> e interventi <strong>straordinari</strong> in base a turni, volumi e criticità.
          </p>

          <p class="text-muted mb-4">
            Operiamo in modo organizzato per ridurre l’impatto sul servizio: concordiamo orari (anche serali/notturni)
            e procedure adatte a ristoranti, mense, hotel, gastronomie e laboratori alimentari.
          </p>

          <!-- ✅ PRODOTTI & APPROCCIO -->
          <div class="card-sami p-3 mb-4">
            <h3 class="fw-bold mb-2">Prodotti e approccio sostenibile</h3>
            <p class="text-muted mb-0">
              Per garantire risultati elevati e ridurre l’impatto ambientale, utilizziamo
              <strong>prodotti Ecolab</strong> e/o <strong>detergenti a basso impatto</strong>.
              Quando indicato, impieghiamo soluzioni <strong>a base enzimatica</strong> per lavorare in modo
              efficace su residui organici e grassi, nel rispetto delle superfici e delle procedure di sicurezza.
            </p>
          </div>

          <ul class="checklist">
            <li>
              <i class="fa-solid fa-check"></i> Sgrassatura piani, banchi e superfici di lavoro
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Pulizia cappe aspiranti, filtri e zone ad accumulo grassi
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Igienizzazione pareti piastrellate e punti critici
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Pulizia forni, griglie, friggitrici (esterni) e attrezzature
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Lavaggio pavimenti e trattamento antiscivolo (se necessario)
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Smaltimento residui e ripristino ordine area lavoro
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Interventi extra: sanificazione certificabile su richiesta
            </li>
          </ul>
        </div>

        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Aree di intervento</h3>

            <ul class="bullets">
              <li>Zone cottura e preparazione</li>
              <li>Cappe, filtri, condotti (fino a dove accessibile)</li>
              <li>Banchi, piani inox e superfici a contatto</li>
              <li>Pavimenti e battiscopa</li>
              <li>Lavaggi e area lavastoviglie</li>
              <li>Celle/frigoriferi (pulizia esterna e aree accessibili)</li>
              <li>Spogliatoi e servizi (su richiesta)</li>
              <li>Magazzini e dispense (su richiesta)</li>
            </ul>

            <div class="note-box mt-3">
              <strong>Nota:</strong> definiamo frequenze e orari per lavorare senza bloccare il servizio.
            </div>

            <!-- ✅ MINI NOTE PRODOTTI -->
            <div class="note-box mt-3">
              <strong>Prodotti:</strong> utilizziamo detergenti professionali (anche <strong>Ecolab</strong>)
              e soluzioni a <strong>basso impatto</strong>, incluse formulazioni <strong>enzimatiche</strong> quando adatte.
            </div>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Vuoi un piano su misura?</div>
              <div class="mini-cta-text">
                Sopralluogo gratuito e preventivo personalizzato.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (2) COME FUNZIONA -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Come funziona</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">
                Valutiamo spazi, flussi e criticità (cappe, filtri, zone grassi).
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Preventivo</div>
              <div class="step-text">
                Definiamo attività, frequenze e orari con costi chiari e trasparenti.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Intervento</div>
              <div class="step-text">
                Operiamo in sicurezza con prodotti professionali (<strong>Ecolab</strong> e/o a basso impatto),
                incluse soluzioni <strong>a base enzimatica</strong> quando indicate.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Controllo qualità</div>
              <div class="step-text">
                Verifica e miglioramenti continui per standard elevati e costanti.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (3) CTA BLU -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">Igiene e sicurezza in cucina, ogni giorno</h2>
      <p class="cta-text">
        Contattaci per un sopralluogo gratuito e un preventivo personalizzato senza impegno.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi preventivo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="mailto:info@samipulizie.it">
          Scrivi una mail
        </a>
      </div>
    </div>
  </section>

  <!-- MAPPA -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            allowfullscreen
            style="border: 0"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index: 1050">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatta su WhatsApp"
      class="btn btn-success rounded-circle btn-sm"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>
</main>
